// Generated by `pnpm generate` — do not edit.
import { createIcon } from '../create-icon';

export const ChevronDownIcon = /* @__PURE__ */ createIcon(
  'chevron-down',
  { fill: 'none', viewBox: '0 0 24 24' },
  [
    [
      'path',
      {
        fill: 'currentColor',
        d: 'M17.293 8.293a1 1 0 1 1 1.414 1.414l-6 6a1 1 0 0 1-1.414 0l-6-6a1 1 0 1 1 1.414-1.414L12 13.586z',
      },
    ],
  ]
);
